import { Link, Status, Text } from '@pega/cosmos-react-core';

export const mockData = [
  {
    id: 'id',
    name: 'ID',
    value: (
      <Text variant='h1' as='span'>
        C-1234
      </Text>
    )
  },
  {
    id: 'status',
    name: 'Status',
    value: <Status variant='pending'>pending</Status>
  },
  {
    id: 'link',
    name: 'Link',
    value: (
      <Link href='https://www.pega.com' target='_blank'>
        C-ABC
      </Link>
    )
  },
  {
    id: 'created',
    name: 'Created',
    value: new Date().toLocaleDateString()
  },
  {
    id: 'no value',
    name: 'No Value'
  }
];

export const mockNumericData = [
  {
    id: 'open',
    name: 'Open',
    value: 405
  },
  {
    id: 'close',
    name: 'Close',
    value: 401
  },
  {
    id: 'year_high',
    name: '52 week high',
    value: 445
  },
  {
    id: 'year_low',
    name: '52 week low',
    value: 335
  }
];
